/**
 * Anclas del pie HT copiadas de Invoice 5019 (EMU).
 * ExcelJS convierte una fracción de columna a un desplazamiento que Excel no respeta,
 * así que la posición se guarda en nativeCol / nativeColOff.
 */
export const HT_FOOTER_IMAGE_ANCHORS = {
  firma: {
    nativeCol: 2,
    nativeColOff: 2254667,
    nativeRow: 56,
    nativeRowOff: 54173,
    width: 93,
  },
  sello: {
    nativeCol: 3,
    nativeColOff: 1116967,
    nativeRow: 55,
    nativeRowOff: 136523,
    width: 163,
  },
  icp: {
    nativeCol: 4,
    nativeColOff: 1552574,
    nativeRow: 57,
    nativeRowOff: 104775,
    width: 250,
  },
};
